import React from 'react';
import PropTypes from 'prop-types';
import s from './MLButtonToggle.module.css';

function classByType(btnType) {
  if (btnType === 'secondary') return s.btnSecondary;
  if (btnType === 'secondaryRed') return s.btnSecondaryRed;
  if (btnType === 'primary') return s.btnPrimary;
  return '';
}

function MLButtonToggle(props) {
  const {
    id,
    idSecondary,
    className,
    classNameContainer,
    classNameSecondary,
    disabled,
    disabledSecondary,
    btnType,
    btnTypeSecondary,
    onClick,
    onClickSecondary,
    btnText,
    btnTextSecondary,
    ariaLabel,
    ariaLabelSecondary,
    children,
    childrenSecondary,
    testIdPrimary,
    testIdSecondary,
  } = props;
  return (
    <div className={`${s.container} ${classNameContainer}`}>
      <button
        id={id}
        data-test-id={testIdPrimary || 'first_toggle_button'}
        className={`${classByType(btnType)} ${className} ${s.leftButton}`}
        disabled={disabled}
        aria-label={btnText || ariaLabel}
        onClick={onClick}
      >
        {btnText || children}
      </button>
      <button
        id={idSecondary}
        data-test-id={testIdSecondary || 'second_toggle_button'}
        className={`${classByType(btnTypeSecondary)} ${classNameSecondary} ${
          s.rightButton
        }`}
        disabled={disabledSecondary}
        aria-label={btnTextSecondary || ariaLabelSecondary}
        onClick={onClickSecondary}
      >
        {btnTextSecondary || childrenSecondary}
      </button>
    </div>
  );
}

MLButtonToggle.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  btnType: PropTypes.string,
  onClick: PropTypes.func,
  btnText: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  idSecondary: PropTypes.string,
  classNameSecondary: PropTypes.string,
  disabledSecondary: PropTypes.bool,
  btnTypeSecondary: PropTypes.string,
  onClickSecondary: PropTypes.func,
  btnTextSecondary: PropTypes.string,
  ariaLabelSecondary: PropTypes.string,
  childrenSecondary: PropTypes.any,
};

export default MLButtonToggle;
